import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { loadScript } from "../../../globals/constants";

function Header2() {
  const [isActive, setIsActive] = useState(false);

  function toggleNavClass() {
    setIsActive(!isActive);
  }

  useEffect(() => {
    loadScript("js/mobilenav.js");
  }, []);

  return (
    <header className={"header-style2 site-header mobile-sider-drawer-menu full-navbar " + (isActive ? "active" : "")}>
      <div className="sticky-header main-bar-wraper navbar-expand-lg">
        <div className="main-bar">
          <div className="container clearfix">
            <div className="logo-header">
              <div className="logo-header-inner logo-header-one">
                <NavLink to="/" className="logo-brand">
                  <img src="/neurologo.png" alt="Neuron Consultancy Kenya logo" className="logo-image" />
                </NavLink>
              </div>
            </div>

            <button id="mobile-side-drawer" data-target=".header-nav" data-toggle="collapse" className="navbar-toggler collapsed" onClick={toggleNavClass}>
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar icon-bar-first" />
              <span className="icon-bar icon-bar-two" />
              <span className="icon-bar icon-bar-three" />
            </button>

            <div className="extra-nav">
              <div className="extra-cell">
                <ul className="list-unstyled social-bx d-flex flex-wrap align-content-center text-white ">
                  <li><a href="https://www.linkedin.com/" title="LinkedIn"><i className="feather-linkedin" /></a></li>
                  <li><a href="https://www.instagram.com/" title="Instagram"><i className="feather-instagram" /></a></li>
                  <li><a href="https://www.facebook.com/" title="Facebook"><i className="feather-facebook" /></a></li>
                  <li><a href="mailto:info@neuronconsultancy.co.ke" title="Email Neuron Consultancy"><i className="feather-mail" /></a></li>
                  <li><a href="tel:+254725642469" title="Call Neuron Consultancy"><i className="feather-phone" /></a></li>
                </ul>
              </div>
            </div>

            <div className="header-nav navbar-collapse collapse d-flex justify-content-center collapse ">
              <ul className="nav navbar-nav ">
                <li><NavLink to="/" end className={({ isActive }) => isActive ? "active" : undefined}>Home</NavLink></li>
                <li><NavLink to="/about-us" className={({ isActive }) => isActive ? "active" : undefined}>About Us</NavLink></li>
                <li><NavLink to="/mission" className={({ isActive }) => isActive ? "active" : undefined}>Mission &amp; Vision</NavLink></li>
                <li><NavLink to="/services" className={({ isActive }) => isActive ? "active" : undefined}>Services</NavLink></li>
                <li><NavLink to="/operations" className={({ isActive }) => isActive ? "active" : undefined}>Operations</NavLink></li>
                <li><NavLink to="/insights" className={({ isActive }) => isActive ? "active" : undefined}>Insights</NavLink></li>
                <li><NavLink to="/contact-us" className={({ isActive }) => isActive ? "active" : undefined}>Contact Us</NavLink></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header2;
